import { render } from "./live_chat.html?vue&type=template&id=5d38ff70&scoped=true&external"
import script from "./live_chat.js?vue&type=script&lang=js&external"
export * from "./live_chat.js?vue&type=script&lang=js&external"

import "./LiveChat.vue?vue&type=style&index=0&id=5d38ff70&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d38ff70"]])

export default __exports__